// extracted by mini-css-extract-plugin
export default {"iframe":"ScoutbookLegacyPage__iframe___RhpiF"};